import React from "react";

export const NotFound = () => {
  return <div>Error 404 - Page Not Found</div>;
};
